module.exports = __webpack_public_path__ + "media/assets/images/curation/close_modal-4cef8f688655f3c34cd90634c7f10783.svg";